
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import {
  Category,
  Content,
  Tag,
  Template,
} from "@/script/apps/cms/entity/CmsEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { DictUtil } from "@/script/core/Dict";
import { CategoryService } from "@/script/apps/cms/service/CategoryService";
import { DictService } from "@/script/apps/system/service/DictService";
import { ElMessage } from "element-plus";
import { AppConfig } from "@/script/core/base/AppConfig";
import { Custom, Dict } from "@/script/apps/system/entity/SystemEntity";
import { TagService } from "@/script/apps/cms/service/TagService";
import { CustomService } from "@/script/apps/system/service/CustomService";
import { ContentService } from "@/script/apps/cms/service/ContentService";
import { TemplateService } from "@/script/apps/cms/service/TemplateService";

@Options({})
export default class CategoryDetail extends BaseDetail {
  private parents: Category[] = [];
  private childCategorys: Category[] = [];
  private childContents: Content[] = [];
  private navTypes: Dict[] = [];
  private listTemplates: Template[] = [];
  private itemTemplates: Template[] = [];
  private detailTemplates: Template[] = [];
  private tagValues: number[] = [];
  private tagOptions: any[] = [];
  private customs: Custom[] = [];

  private service = new CategoryService();

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_cms_category",
      "/cms/category",
      "/cms/category",
      this.service
    );
    data.typesName = "category-type";
    return data;
  }

  private rules = {
    code: [{ required: true, message: "请输入编码", trigger: "blur" }],
    name: [{ required: true, message: "请输入名称", trigger: "blur" }],
  };

  protected initOptions() {
    super.initOptions();
    this.service.loadParentCategorys(this.id, (data: any) => {
      this.parents = data;
    });
    this.service.loadChildCategorys(this.id).then((result: any) => {
      this.childCategorys = result.data.list;
    });

    const contentService = new ContentService();
    contentService.loadChildContents(this.id).then((result: any) => {
      this.childContents = result.data.list;
    });
    const tagService = new TagService();
    tagService.loadTagsByType("category", (data: any) => {
      const tags: Tag[] = data;
      this.tagOptions = [];
      tags.forEach((item) => {
        this.tagOptions.push({
          value: item.id,
          label: item.name,
        });
      });
    });
    const dictService = new DictService();
    dictService.loadChildItems("category-nav-type", (data: any) => {
      this.navTypes = data;
    });

    const templateService = new TemplateService();
    templateService.loadListByType("list").then((result: any) => {
      this.listTemplates = result.data.list;
    });
    templateService.loadListByType("index").then((result: any) => {
      this.itemTemplates = result.data.list;
    });
    templateService.loadListByType("content").then((result: any) => {
      this.detailTemplates = result.data.list;
    });

    const customService = new CustomService();
    customService.loadAllList("/api/sys/custom/list", (data: any) => {
      this.customs = data.list;
    });
  }

  public newEntity() {
    const entity: Category = {};
    const parentId = this.$route.query.parentId;
    if (parentId) {
      entity.parentId = Number(parentId);
    }
    entity.sortNo = 1;
    entity.type = "template";
    entity.mobileEnable = false;
    entity.navType = "list";
    entity.sortType = "desc";
    entity.pageSize = 20;
    // entity.listTemplateId = 100;
    // entity.detailTemplateId = 200;
    entity.listTemplate = "/cms/default/list.ftl";
    entity.detailTemplate = "/cms/default/content.ftl";
    entity.staticize = false;
    entity.nav = false;
    return entity;
  }

  uploadFile(param: any) {
    const path = "cms";
    const formData = new FormData();
    formData.append("path", path);
    formData.append("files", param.file, param.file.name);
    this.service.uploadFile(formData).then(
      (result) => {        
          const uploadUrl =
          AppConfig.Config.ServerUrl + `file/${path}/${result.data}`;
        this.entity.img = uploadUrl;
      },
      (error: Error) => {
        ElMessage.error("上传图片失败！原因：" + error);
      }
    );
  }

  afterLoad(data: any) {
    if (this.entity.tagIds) {
      const tagIds: [] = this.entity.tagIds.split(",");
      this.tagValues = [];
      tagIds.forEach((item) => {
        this.tagValues.push(Number(item));
      });
    }
  }

  beforeSave() {
    const tagIds = this.tagValues.join(",");
    this.entity.tagIds = tagIds;
    const category = this.entity as Category;

    if (category.listTemplateId) {
      this.listTemplates.forEach((item) => {
        if (item.id === category.listTemplateId) {
          category.listTemplate = item.path;
        }
      });
    } else {
      category.listTemplate = "";
    }
    if (category.indexTemplateId) {
      this.itemTemplates.forEach((item) => {
        if (item.id === category.indexTemplateId) {
          category.indexTemplate = item.path;
        }
      });
    } else {
      category.indexTemplate = "";
    }
    if (category.detailTemplateId) {
      this.detailTemplates.forEach((item) => {
        if (item.id === category.detailTemplateId) {
          category.detailTemplate = item.path;
        }
      });
    } else {
      category.detailTemplate = "";
    }
    return true;
  }

  private pinyin() {
    const category = this.entity as Category;
    this.service.pinyin(category.name!).then((result: any) => {
      category.code = result.data;
    });
  }
}
